export default (state, action) => {
  if (!state) {
    return { campaigns: null };
  }

  switch (action.type) {
    case 'CAMPAIGNS_RECEIVE': {
      return {
        ...state,
        campaigns:
          action.campaigns &&
          action.campaigns.filter(campaign => campaign.state === 'ACTIVE'),
      };
    }
    default:
  }

  return state;
};
